const PCI_BIN_SIZE = 8;
const PCI_BIN_PATTERN = new RegExp(`^\\d{${PCI_BIN_SIZE}}`);
const PCI_EXPIRATION_MONTH_PATTERN = /(0[1-9])|1[0-2]/;
const PCI_EXPIRATION_YEAR_PATTERN = /[2-9]\d/;

export const getPCIBinFromEntry = (cardNumber: string | undefined): string =>
  cardNumber && PCI_BIN_PATTERN.test(cardNumber)
    ? cardNumber.slice(0, PCI_BIN_SIZE)
    : '';

export const getPCIExpirationMonthFromEntry = (
  date: string | undefined
): string => (date && PCI_EXPIRATION_MONTH_PATTERN.test(date) ? date : '');

export const getPCIExpirationYearFromEntry = (
  date: string | undefined
): string => (date && PCI_EXPIRATION_YEAR_PATTERN.test(date) ? date : '');
